import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled"];
export default function getStepperPropsWithClearedDisabledProp(stepperInputProps) {
  if (stepperInputProps) {
    const rest = _objectWithoutPropertiesLoose(stepperInputProps, _excluded);
    return rest;
  }
  return {};
}